import { Button } from 'antd';
import { AsyncSVG } from '../AsyncSVG';

export default function URLChooser ({
    buttonBackground,
    children,
}) {
    return (
        <Button aria-label="URL Chooser" className={`action-button ${buttonBackground}`}>
            <span>
                <AsyncSVG className="cloud-upload-icon" src="/images/upload-link-white.svg" />
                {children}
            </span>
        </Button>
    );
};